import PropTypes from 'prop-types';
import moment from 'moment';
import { useEffect, useState } from 'react';
// material
import { TableRow, TableCell, Button, FormControl, Menu,Select, MenuItem, DialogContent, Stack, TextField, DialogActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from "../../../assets/icons/icon_edit.svg";
import DeleteIcon from "../../../assets/icons/icon_trash.svg";
import { addJoinDataSet, refreshDataSetsWithAthena, resyncJoinDataset, updateDataSetJoin, updateDatasets } from '../../../config/services/datasets';
import toast from 'react-hot-toast';
import { addVersion } from '../../../config/services/config';
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import Popup from '../../Popup';
import { ReactComponent as RefreshIcon } from "../../../assets/icons/icon-refresh.svg"
import { DecryptData } from "../../../utils/encryptDecrypt"


export default function DatasetsRow({ dataset, openInPopup, deleteDataset, handleDataSetEdit, index, setLoading, handleDatasetAccess, activeDataSource }) {
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState(false)
    const [moreMenuEl, setMoreMenuEl] = useState(null)
    const [selectedDataset, setSelectedDataset] = useState({})
    const [datasetName, setDatasetName] = useState(dataset?.displayName || dataset?.dataSetName)
    const [datasetDescription, setDatasetDescription] = useState(dataset?.datasetDescription || '')
    const [refreshKeyField, setRefreshKeyField] = useState(dataset?.refreshKeyField || '')
    const [joinNamePopup, setJoinNamePopup] = useState(false)
    const [refreshKeyPopup, setRefreshKeyPopup] = useState(false)
    const [refreshKey,setRefreshKey] = useState(dataset?.refreshKey || 'dynamic')
    const [fieldList,setFieldList] = useState([])

    const editButton = (dataset) => {
        return (
            <Button disabled={isCurrentDataSource(dataset, 'edit')} className='form_icon' onClick={() => handleRedirect(dataset?._id)}><img src={EditIcon} /></Button>
        )
    }
    const deleteButton = (params, isDelete = false) => {
        return (
            <Button disabled={isCurrentDataSource(params, 'delete') || isDelete ? true : false} className='form_icon' onClick={() => deleteDataset(params)}><img src={DeleteIcon} /></Button>
        )
    }
    const handleRedirect = (datasetId) => {
        dataset.mode = 'edit';
        //navigate(`/dataset/${datasetId}/prepare`, { state: dataset})
        handleDatasetAccess('edit', `/dataset/${datasetId}/prepare`, { state: dataset })
    }

    const isCurrentDataSource = (params, type) => {
        const { dataSource, joinConfig } = params;
        if (!activeDataSource) {
            if (!dataSource) {
                return false
            }
            return true
        }
        else {
            const { _id } = activeDataSource
            if (dataSource?._id === _id) {
                if (joinConfig && Object.keys(joinConfig).length > 0 && type == 'refresh') {
                    return true
                }
                return false
            } else {
                return true
            }
        }
    }

    const refreshButton = (params) => {
        return (
            <Button className='form_icon' disabled={isCurrentDataSource(params, 'refresh') || refresh} title="Resync" onClick={() => handleDatasetResync(params)} ><RefreshIcon /></Button>
        )
    }

    const moreButton = (params) => {
        return (
            <Button className='form_icon' onClick={(e) => openMoreMenu(e, params)} ><MoreIcon /></Button>
        )
    }

    const openMoreMenu = (e, params) => {
        //console.log(params)
        setSelectedDataset(params)
        setMoreMenuEl(e.target)
    }

    const handleMoreMenuClose = () => {
        setMoreMenuEl(null)
    }

    const handleDatasetResync = async (params) => {
        setRefresh(true)
        setLoading(true)

        if (dataset?.joinDatasetsProps && dataset?.edgeConfig.length) {
            params.reSyncDataset = true
            params.dataSetId = params?._id
            const res = await resyncJoinDataset(params)
            await addVersion({ version: new Date().getTime().toString() })
            toast.success(res?.message)
            setRefresh(false)
            setLoading(false)

        }
        else {
            params.dataSetId = params?._id
            const res = await refreshDataSetsWithAthena(params)
            await addVersion({ version: new Date().getTime().toString() })
            if (res?.list && res?.list?.Items && res?.list?.Items.length) {
                let selectedDataSet = DecryptData(localStorage.getItem("selectedDataSetObj"));
                if (selectedDataSet) {
                    selectedDataSet = JSON.parse(selectedDataSet)
                    const exist = res?.list?.Items.find(r => r?.row === selectedDataSet?.tableName);
                    if (!exist) {
                        localStorage.removeItem("selectedDataSetObj")
                    }
                }
            }
            toast.success(res?.message)
            setRefresh(false)
            setLoading(false)
        }


    }
    const handleDataSetEditSave = () => {
        //console.log(selectedDataset)
        const params = {
            displayName: datasetName,
            dataSource: selectedDataset?.dataSource || null,
            dataSetDescription: datasetDescription,
            dataSetId: selectedDataset?._id,
            dataSetName: selectedDataset?.dataSetName,
            tableAlias: selectedDataset?.tableAlias,
            sql: selectedDataset?.sql
        }
        setMoreMenuEl(null)
        handleDataSetEdit(params)
        setJoinNamePopup(false)
    }

    const handleInternalJoin = (dataset) => {
        console.log(dataset)
    }

    const handleManageDataset = (datasetId) => {
         navigate('/manageDataset/'+datasetId )
    }

    const handleRefreshKeyType = (e) => {
        //console.log(selectedDataset,dataset)
        setRefreshKey(e.target.value)
        if(e.target.value == dataset?.refreshKey){
            setRefreshKeyField(dataset.refreshKeyField)
        }else if(e.target.value == 'realTime'){
            setRefreshKeyField(`5 minute`)
        }else{
            setRefreshKeyField('')
        }
    }

    const handleRefreshKeyField = (e) => {
        setRefreshKeyField(e.target.value)
    }

    const handleRefreshKeyUpdate = () => {
        setMoreMenuEl(null)
        let updateObj = {
            dataSetId:dataset._id,
            dataSetName:dataset.dataSetName,
            dataSource:dataset.dataSource,
            refreshKey,
            refreshKeyField
        }
        if(refreshKey && refreshKeyField){
            updateDatasets(updateObj)
            .then(
                res => {
                    if(res.result){
                        setRefreshKeyPopup(false)
                        toast.success('Refresh Key Updated Successfully')
                    }else{
                        let msg = res?.data?.error?.errorMessage
                        toast.error(msg ?? 'Something went wrong, Please Contact Administrator')
                    } 
                }
            )
            .catch(
                err => {
                    toast.error(err?.message ?? 'Something went wrong, Please try after sometime')
                }
            )
        }else{
            toast.error('Please Provide Values for Refresh Key')
        }
    }
    useEffect(() => {
        //console.log(dataset)
        setRefreshKey(dataset?.refreshKey ?? 'dynamic')
        setRefreshKeyField(dataset?.refreshKeyField ?? '')
    },[refreshKeyPopup])
    useEffect(() => {
        let list = dataset.dimensions.filter(obj => obj.type == 'time' && !obj.calulatedField)
        setFieldList(list)
        if(list.length < 1){
            setRefreshKey('realTime')
        }
    },[])
    return (
        <TableRow key={dataset?._id}>
            <TableCell>{index}</TableCell>
            <TableCell className="datasetname-cell">{dataset?.displayName || dataset?.dataSetName}</TableCell>
            <TableCell> {moment(dataset?.updatedAt).fromNow()} </TableCell>

            {
                dataset?.accessType !== 'view' && (
                    <>
                        <TableCell className="edit-cell action-cell">{editButton(dataset)}
                            {(deleteButton({ _id: dataset?._id, dataSetName: dataset?.dataSetName, dataSource: dataset?.dataSource }))}
                            {refreshButton(dataset)}
                            {moreButton(dataset)}</TableCell>
                    </>
                )
            }
            <Menu
                style={{ marginRight: '10px' }}
                id="simple-menu"
                anchorEl={moreMenuEl}
                keepMounted
                open={Boolean(moreMenuEl)}
                onClose={e => handleMoreMenuClose()}

            >
                <MenuItem className='menu-item' onClick={e => setJoinNamePopup(true)}>Edit Name/Description</MenuItem>
                <MenuItem className='menu-item' onClick={e => setRefreshKeyPopup(true)}>Change Refresh Key</MenuItem>
                <MenuItem className='menu-item' onClick={() => handleManageDataset(dataset?._id)}>Manage Dataset</MenuItem>
                {
                //<MenuItem className='menu-item' onClick={() => handleInternalJoin(dataset)}>Manage Internal Join</MenuItem>
                }
                
            </Menu>

            <Popup
                title={'Update Field'}
                openPopup={joinNamePopup}
                setOpenPopup={setJoinNamePopup}
            >
                <DialogContent className="custom-modal-content">
                    <Stack>
                        <FormControl fullWidth>
                            <label>Dataset Name</label>
                            <TextField defaultValue={dataset.dataSetName} onChange={e => setDatasetName(e.target.value)} className="select_min_width" placeholder="Dataset Name" />
                        </FormControl>
                        <FormControl fullWidth>
                            <label>Dataset Description</label>
                            <TextField onChange={e => setDatasetDescription(e.target.value)} value={dataset.datasetDescription} className="select_min_width" placeholder="Dataset Description" />
                        </FormControl>
                    </Stack>
                </DialogContent>
                <DialogActions className="btn-group">
                    <Button color="error" className="report_form_ui_btn cancel mr-2" onClick={() => setJoinNamePopup(false)}> Cancel </Button>
                    <Button color="primary" className="report_form_ui_btn submit" onClick={handleDataSetEditSave} autoFocus > Save </Button>
                </DialogActions>

            </Popup>

            <Popup
                title={`Change Refresh Key (${dataset?.displayName ?? dataset.dataSetName})`}
                openPopup={refreshKeyPopup}
                setOpenPopup={setJoinNamePopup}
            >
                <DialogContent className="custom-modal-content">
                    <Stack>
                        <FormControl fullWidth>
                            <label>Dataset Name</label>
                            <Select
                                defaultValue={refreshKey}
                                onChange={handleRefreshKeyType}
                            >
                                {fieldList.length > 0 && <MenuItem key={'dynamic'} value={`dynamic`}>Dynamic</MenuItem>}
                                <MenuItem key={'static'} value={`realTime`}>Static</MenuItem>
                            </Select>
                        </FormControl>
                        {
                            (refreshKey == 'dynamic') && 
                            <Select
                                defaultValue={refreshKeyField}
                                onChange={handleRefreshKeyField}
                            >
                                {
                                    fieldList.length > 0 && fieldList.map(obj => (
                                        <MenuItem key={obj._id} value={obj.name}>{obj?.displayName || obj.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        }
                        {
                            (refreshKey == 'realTime') && 
                            <FormControl fullWidth>
                                <label>Refresh Key Value</label>
                                <TextField onChange={e => setRefreshKeyField(e.target.value)} value={refreshKeyField} className="select_min_width" placeholder="e.g:- 1 minute, 5 second, 5 minute, etc" />
                            </FormControl>
                        }
                        
                    </Stack>
                </DialogContent>
                <DialogActions className="btn-group">
                    <Button color="error" className="report_form_ui_btn cancel mr-2" onClick={() => setRefreshKeyPopup(false)}> Cancel </Button>
                    <Button color="primary" className="report_form_ui_btn submit" onClick={handleRefreshKeyUpdate} autoFocus > Save </Button>
                </DialogActions>

            </Popup>

        </TableRow>
    )
}
DatasetsRow.propTypes = {
    dataset: PropTypes.object
}
